import { AlkLogger } from '@alk/core';
import { IMultipleDelayedActionService } from './multiple-delayed-action.interface';
import { injectable } from 'inversify';

@injectable()
export class MultipleDelayedActionMock implements IMultipleDelayedActionService {
    init(): void {
        AlkLogger.debug('[MultipleDelayedActionMock#init]');
    }
    add(): void {
        AlkLogger.debug('[MultipleDelayedActionMock#add]');
    }
    remove(): void {
        AlkLogger.debug('[MultipleDelayedActionMock#remove]');
    }
    flush(): void {
        AlkLogger.debug('[MultipleDelayedActionMock#flush]');
    }
}
